var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGumroadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37834_12895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3541 19.4998C16.1291 19.4998 20 15.8393 20 11.3238C20 6.80828 16.1291 3.14771 11.3541 3.14771C6.579 3.14771 2.70801 6.80828 2.70801 11.3238C2.70801 15.8393 6.579 19.4998 11.3541 19.4998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12266 17.7863C14.1449 17.7863 18.2453 13.9323 18.2453 9.14329C18.2453 4.35438 14.1449 0.500244 9.12266 0.500244C4.1005 0.500244 0 4.35438 0 9.14329C0 13.9323 4.1005 17.7863 9.12266 17.7863Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43655 13.5035C5.88341 13.5035 4.38159 11.4827 4.38159 8.96899C4.38159 6.35667 6.03357 4.2373 9.18737 4.2373C12.4414 4.2373 13.5427 6.40602 13.5927 7.63815H11.2399C11.1899 6.94815 10.5891 5.91311 9.13735 5.91311C7.58552 5.91311 6.58427 7.24389 6.58427 8.87041C6.58427 10.4969 7.58552 11.8276 9.13735 11.8276C10.5391 11.8276 11.1398 10.7433 11.3901 9.65906H9.13735V8.77183H13.8643V13.3063H11.7906V10.4476C11.6404 11.4827 10.9896 13.5035 8.43655 13.5035Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37834_12895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGumroadLogo);
export default __webpack_public_path__ + "static/media/gumroad-logo.51ad988a344eb5b3078469975c7bc3cc.svg";
export { ForwardRef as ReactComponent };